export default __webpack_public_path__ + "static/media/blush-dark-winter.5c1999df.png";